import { Card, CardContent, CardHeader } from '@shared/components/ui/card';
import { Skeleton } from '@shared/components/ui/skeleton';
import { cn } from '@shared/lib/utils';

interface DataTableSkeletonCardsProps {
  cardCount?: number;
  className?: string;
}

export function DataTableSkeletonCards({
  cardCount = 5,
  className,
}: DataTableSkeletonCardsProps) {
  const skeletonCards = Array.from({ length: cardCount }, (_, index) => index);

  return (
    <div className={cn('bg-gray-25', className)}>
      {skeletonCards.map((index) => (
        <div key={`skeleton-card-${index}`} className="mb-3 p-[2px]">
          <Card className="min-w-96 border-primary-50">
            <CardHeader className="space-y-1">
              <div className="flex flex-row items-center">
                <Skeleton className="mr-4 h-6 w-48 rounded" />
                <Skeleton className="ml-auto h-6 w-16 rounded" />
              </div>
              <div className="flex flex-wrap gap-1">
                <Skeleton className="h-5 w-20 rounded" />
                <Skeleton className="h-5 w-16 rounded" />
              </div>
            </CardHeader>
            <CardContent className="flex flex-row items-end">
              <div className="flex w-full max-w-xl flex-row space-x-2">
                <div className="min-w-20">
                  <Skeleton className="mb-1 h-8 w-32 rounded" />
                </div>
              </div>
              <div className="ml-auto flex min-h-full items-end justify-end pl-4">
                <Skeleton className="h-8 w-24 rounded" />
              </div>
            </CardContent>
          </Card>
        </div>
      ))}
    </div>
  );
}
